exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3,h4{font-weight:500}a,a:hover{color:#0c3a6d}#cimap,.portal-container{font-family:'Soleil';font-size:1em}#cimap button,.portal-container button{font-size:inherit}@media (max-height: 800px), (max-width: 1024px){#cimap,.portal-container{font-size:0.8335em}}button{text-decoration:none;background:none;border:none;cursor:pointer}.close-btn{position:absolute;top:0;right:0.5em;padding:0.5em}.close-btn:after{content:\"\\2716\"}.spinner{width:1.5em;height:1.5em;animation:spin 1.5s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n", ""]);

// exports
